import Alert from "@amzn/meridian/esm/components/alert";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Text from "@amzn/meridian/esm/components/text";
import TranscribeBox from "./TranscribeBox";
import LearnMoreLink from "../../components/LearnMoreLink";
import { TRANSCRIPT_NOT_AVAILABLE_MESSAGE } from "../../constants";

/**
 * Shown when transcription is not available for the current meeting — hosts in
 * meetings marked not eligible by `/is-aims-available`, and everyone who is not
 * an organizer / alternative host. Renders the shared TranscribeBox frame with
 * a "Not available" badge plus a "Learn more" link to the wiki.
 */
const TranscribeNotAvailable = () => {
  return (
    <Column spacing="400" spacingInset="600 none none none" alignmentHorizontal="center">
      <TranscribeBox
        badge={
          <Alert type="warning" size="small">
            Not available
          </Alert>
        }
      />

      <Box maxWidth="226px">
        <Column spacing="400">
          <Text type="h50" color="secondary" alignment="start">
            Start taking notes
          </Text>
          <Text type="b200" color="secondary">
            {TRANSCRIPT_NOT_AVAILABLE_MESSAGE}
          </Text>
          <LearnMoreLink />
        </Column>
      </Box>
    </Column>
  );
};

export default TranscribeNotAvailable;
